import React, { useEffect, useState, useContext } from "react"

import { Link } from "gatsby"
import { Row, Col } from "react-bootstrap"

import Edit from "../../../images/icons/wdn-edit.png"
import Wrong from "../../../images/icons/wdn-wrong.png"
import Warning from "../../../images/icons/wdn-warning.png"

import { GlobalAuthContext } from "../../../context/authContext"

import "./education-form.scss"
import Spinner from "../../spinner/spinner"
import TimeLineEducation from "../timeline-education"
import "../../../../node_modules/react-datepicker/dist/react-datepicker.css"
import { CANDIDATE_PROFILE_SUBMIT } from "../actions/socialAction"

const EducationForm = props => {
  const {
    education,
    images,
    setAddTraining,
    setAddEducation,
    isLoading,
    setDelete,
  } = props

  const [errors, setErrors] = useState({})
  const [isProcessing, setProcessing] = useState(false) // eslint-disable-line no-unused-vars

  const { state, dispatch } = useContext(GlobalAuthContext)

  const handleEducationEdit = (value, id) => {
    setAddEducation(value, id)
  }

  const handleSubmit = e => {
    e.preventDefault()
    setProcessing(true)
    CANDIDATE_PROFILE_SUBMIT(
      setErrors,
      setProcessing,
      true,
      dispatch,
      state?.path
    )
  }

  useEffect(() => { }, [education, images])

  return (
    <div className="education-form ">
      <Row className="align-items-center">
        <Col xs="6" md="8">
          <div className="d-flex align-items-center">
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label className="mb-0">
              Education<span>*</span>
            </label>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a aria-hidden="true" onClick={() => setAddEducation(true)}>
              <span className="btn-custom plus ml-1 blue text-center d-block">
                +
              </span>
            </a>
          </div>
        </Col>
        <Col xs="6" md="4" className="text-right"></Col>
      </Row>
      <div className="separator-border"></div>
      {isLoading ? (
        <Spinner />
      ) : education.length > 0 && education.length !== undefined ? (
        <Row>
          <Col>
            <TimeLineEducation
              onClick={handleEducationEdit}
              educations={education}
              setDelete={setDelete}
            />
          </Col>
        </Row>
      ) : (
        <Row>
          <Col>
            <p>Nothing to show.</p>
          </Col>
        </Row>
      )}
      <Row className="align-items-center">
        <Col xs="6" md="8">
          <div className="d-flex align-items-center">
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label className="mb-0">Training / Certificate</label>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a
              aria-hidden="true"
              onClick={() => setAddTraining(true)}
              className="btn-custom blue plus ml-1 text-center d-block"
            >
              +
            </a>
          </div>
        </Col>
        <Col xs="6" md="4" className="text-right"></Col>
      </Row>
      <div className="separator-border"></div>
      <Row className="mb-4  ">
        {isLoading ? (
          <Spinner />
        ) : images && images.length > 0 ? (
          <>
            {images.map((image, index) => {
              return (
                <Col
                  key={index}
                  sm="6"
                  lg="4"
                  className="mb-4 portfolio-images__wrapper d-flex align-items-center justify-content-center"
                >
                  <div className="buttons hide-buttons d-flex align-items-center">
                    <div className="cross">
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a
                        aria-hidden="true"
                        onClick={() => setAddTraining(true, image.id)}
                      >
                        <img src={Edit} alt="wdn-edit" />
                      </a>
                    </div>
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a
                      aria-hidden="true"
                      onClick={() => setDelete(true, image.id, "TRAINING")}
                    >
                      <div className="cross">
                        <img src={Wrong} alt="wdn-cross" />
                      </div>
                    </a>
                  </div>

                  <img
                    className="portfolio-image"
                    src={image.image}
                    alt={image.title ? image.title : "Education Image"}
                  />
                </Col>
              )
            })}
            <div className="separator-border"></div>
          </>
        ) : (
          <Col>
            <p>Nothing to show.</p>
          </Col>
        )}
      </Row>
      <Row>
        <Col>
          {errors &&
            Object.keys(errors)
              .slice(0, 1)
              .map((key, value) => {
                return (
                  <div
                    key={value}
                    className="alert-block mb-4 d-flex align-items-center"
                  >
                    <img src={Warning} className="mr-3" alt="wdn-warning" />
                    {errors[key]}
                  </div>
                )
              })}
        </Col>
      </Row>

      <Row>
        <Col lg={{ span: "3", offset: "5" }}>
          <Link
            to="/candidate/professional"
            className="btn w-100 btn-custom rounded  p-3 blue-outline my-2"
          >
            Back
          </Link>
        </Col>

        <Col lg={{ span: "4" }}>
          <button
            onClick={handleSubmit}
            className="btn w-100 btn-custom p-3 rounded primary my-2"
            disabled={isProcessing}
          >
            {isProcessing ? "Processing" : "Submit"}
          </button>
        </Col>
      </Row>
    </div>
  )
}

export default EducationForm
